import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { setupSentry } from './services/sentry/helper.tsx'
import { MangoSplash} from '@intellihr/blueberry'
import { instantiateNewRelic } from './services/newRelic/helper.tsx'

instantiateNewRelic()

setupSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<MangoSplash />}>
    <App />
    </Suspense>
  </StrictMode>,
)
